export default __webpack_public_path__ + "static/media/wallet_status.e9fefde1.svg";